import { render, staticRenderFns } from "./ListPickerChannels.vue?vue&type=template&id=04e021cf&scoped=true&"
import script from "./ListPickerChannels.vue?vue&type=script&lang=js&"
export * from "./ListPickerChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e021cf",
  null
  
)

export default component.exports